/** @file Refills a reused Set with a selection list (no Set, array or iterator allocated per call). */

/** Clears `set`, adds every entry of `values` (none when undefined) and returns it. */
export function refillSet(set: Set<number>, values: readonly number[] | undefined): Set<number> {
  set.clear();
  if (values === undefined) return set;
  for (let k = 0; k < values.length; k++) {
    const v = values[k];
    if (v !== undefined) set.add(v);
  }
  return set;
}
